import Vue from 'vue'
import forEach from 'lodash/forEach'
import Global from '@/components/common'

/** Register all global components */
forEach(Global, (value, key) => {
  Vue.component(key, value)
})